module.exports = __webpack_public_path__ + "img/cavalier-challenge-1_191e8d3840b4f7cb1cbe2f5481ecad02.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/cavalier-challenge-1.jpg
// module id = 259
// module chunks = 0